import type { LocaleMessageBundle } from '../../types'
import { cashBookMessages } from './cash-book'
import { cashTransactionMessages } from './cash-transaction'
import { dashboardMessages } from './dashboard'
import { developerInfoMessages } from './developer-info'
import { errorMessages } from './errors'
import { navigationMessages } from './navigation'
import { paymentMethodMessages } from './payment-method'
import { statisticsDateFilterMessages } from './statistics-date-filter'
import { statusMessages } from './status'
import { systemSettingMessages } from './system-setting'
import { printTemplateMessages } from './print-template'
import { tableMessages } from './table'
import { validationMessages } from './validation'
import { activityLogMessages } from './activity-log'
import { voucherMessages } from './voucher'
import { shiftRevenueReportMessages } from './shift-revenue-report'
import { shiftClosingReportMessages } from './shift-closing-report'
import { dayClosingReportMessages } from './day-closing-report'

export const sharedMessages: LocaleMessageBundle = {
  vi: {
    ...dashboardMessages.vi,
    ...errorMessages.vi,
    ...navigationMessages.vi,
    ...statisticsDateFilterMessages.vi,
    ...statusMessages.vi,
    ...systemSettingMessages.vi,
    ...printTemplateMessages.vi,
    ...tableMessages.vi,
    ...validationMessages.vi,
    ...paymentMethodMessages.vi,
    ...cashBookMessages.vi,
    ...cashTransactionMessages.vi,
    ...activityLogMessages.vi,
    ...voucherMessages.vi,
    ...shiftRevenueReportMessages.vi,
    ...shiftClosingReportMessages.vi,
    ...dayClosingReportMessages.vi,
    ...developerInfoMessages.vi,
    'confirmation.delete': 'Xác nhận xóa',
    'confirmation.verify': 'Xác nhận thông tin',
    'common.updated-successfully': 'Cập nhật thành công.',
  },
  en: {
    ...dashboardMessages.en,
    ...errorMessages.en,
    ...navigationMessages.en,
    ...statisticsDateFilterMessages.en,
    ...statusMessages.en,
    ...systemSettingMessages.en,
    ...printTemplateMessages.en,
    ...tableMessages.en,
    ...validationMessages.en,
    ...paymentMethodMessages.en,
    ...cashBookMessages.en,
    ...cashTransactionMessages.en,
    ...activityLogMessages.en,
    ...voucherMessages.en,
    ...shiftRevenueReportMessages.en,
    ...shiftClosingReportMessages.en,
    ...dayClosingReportMessages.en,
    ...developerInfoMessages.en,
    'confirmation.delete': 'Confirm delete',
    'confirmation.verify': 'Verify information',
    'common.updated-successfully': 'Updated successfully.',
  },
}
